import React from 'react';
import UserContext from '../UserContext';

export default function UserProvider(props) {
  const { children } = props;
  return <UserContext.Provider>{children}</UserContext.Provider>;
}
